<template>
  <div :id="componentId" class="spm6-story" :style="{ backgroundColor: bgColor }">
    <div class="spm6-story-grid">
      <div
        class="spm6-story-card"
        v-for="(item, index) in list"
        :key="index"
        @click="goTo(item)"
      >
        <div class="spm6-story-image-wrapper">
          <img class="spm6-story-image" referrerpolicy="no-referrer" :src="item.imageUrl" />
          <div v-if="item.isVideo" class="spm6-story-play-btn">
            <div class="spm6-play-circle">
              <img src="/play-btn.png" alt="播放" class="spm6-play-icon" />
            </div>
          </div>
        </div>
        <span class="spm6-story-title" v-html="item.title"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileStorySection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_6'
    }
  },
  data() {
    return {
      bgColor: '#F3F3F3',
      list: [
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false },
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false },
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG387a09863e01f489b14d15cf44651796.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false },
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false },
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false },
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false },
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG387a09863e01f489b14d15cf44651796.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false },
        { imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png', title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', url: '', articleCode: '', isVideo: false }
      ]
    }
  },
  methods: {
    goTo(item) {
      let targetUrl = ''
      if (item.url && item.url.indexOf('/zp/a') !== -1) {
        targetUrl = 'detail?newsCode=' + item.articleCode
      } else {
        targetUrl = item.url
      }
      if (!targetUrl) return
      window.open(targetUrl, '_blank')
    }
  }
}
</script>

<style scoped>
.spm6-story {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm6-story-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.spm6-story-card {
  cursor: pointer;
  background: #F9F9F9;
  border-radius: 8px;
  overflow: hidden;
}

.spm6-story-image-wrapper {
  position: relative;
  width: 100%;
}

.spm6-story-image {
  width: 100%;
  height: auto;
  aspect-ratio: 332 / 187;
  object-fit: cover;
  display: block;
}

.spm6-story-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.spm6-play-circle {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 20px 15px rgba(255, 255, 255, 0.55), 0 0 6px 2px rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

.spm6-play-icon {
  width: 60px;
  height: 60px;
  display: block;
}

.spm6-story-title {
  display: block;
  margin: 6px 0;
  padding: 0 8px;
  font-size: 12px;
  line-height: 16px;
  color: #333;
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
